var path = 'app/reporting/campaign_specific/viewViewers.html';
var html = "<div ng-include=\"'app/reporting/shared/reportsViewersVisitorsList.html'\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;